import { z } from "zod";
/**
 * The app a public Twin request comes from, as runs, receipts, posts and
 * comments record it: an agent's tool, or Desk, MLX's macOS client. Clients
 * name it in `x-mlx-client-app` or, where an operation takes one, `clientApp`.
 */
export const externalClientAppSchema = z.enum([
    "claude-code",
    "codex",
    "gemini",
    "chatgpt",
    "desk",
]);
/** The client app a recorded value names, or undefined when it names none. */
export function externalClientApp(value) {
    return externalClientAppSchema.options.includes(value)
        ? value
        : undefined;
}
